import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_grid2d, use_slice_search } from '@/hooks/store/use_slices';
import { remote_grid2d_get_search } from '@/state/grid2d/grid2d_for_entity/remote_grid2d_get_search';
import { is_grid2d_loading } from '@/utils/utils_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';

export function WatcherGetGrid2dSearchCurrent() {
  const dispatch = use_dispatch();

  const { search_current } = use_slice_search(['search_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (search_current.is_stub()) return;
    if (grids2d_map.has(search_current._id)) return; //already loaded
    if (is_grid2d_loading(ENUM__workspace_entity.ENTITY_SEARCH, search_current._id)) return; //already loading

    void dispatch(remote_grid2d_get_search(search_current._id));
  }, [search_current]);

  return <></>;
}
